export const BULK_ACTION_NAME = {
  SMS: 'sms',
  Email: 'email',
  Call: 'call',
  Stage: 'stage',
  Sign: 'sign',
  BackgroundCheck: 'backgroundCheck',
  AssignTraining: 'assignTraining',
  RecruiterAssignment: 'recruiterAssignment',
  MemberAssignment: 'memberAssignment',
} as const

export type BulkActionName =
  (typeof BULK_ACTION_NAME)[keyof typeof BULK_ACTION_NAME]

export type SelectedApplicant = {
  applicantId: string
  name: string
  email: string
}

export type BulkActionResult = {
  applicantId: string
  success: boolean
  errorMsg?: string
}
